import { render, staticRenderFns } from "./professionDialog.vue?vue&type=template&id=deb52838"
import script from "./professionDialog.vue?vue&type=script&lang=js"
export * from "./professionDialog.vue?vue&type=script&lang=js"
import style0 from "./professionDialog.vue?vue&type=style&index=0&id=deb52838&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports